module.exports = __webpack_public_path__ + "static/media/foto4.4de188f6.jpg";